import { UserEntityPreferredLanguage } from "@/api/__generated__/orval/auth";

export const formatPrice = ({
  price,
  maxDigits = 2,
  locale,
  currency = "€",
}: {
  price: number;
  maxDigits?: number;
  locale?: UserEntityPreferredLanguage;
  currency?: string;
}) => {
  const resolvedLocale = locale ?? UserEntityPreferredLanguage.fr;

  return new Intl.NumberFormat(resolvedLocale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: maxDigits,
  })
    .format(price / 100)
    .concat(` ${currency}`);
};

export const getDecimalSeparator = ({
  maxDigits = 2,
  locale,
}: {
  maxDigits?: number;
  locale?: UserEntityPreferredLanguage;
}) => {
  const resolvedLocale = locale ?? UserEntityPreferredLanguage.en;

  return (
    new Intl.NumberFormat(resolvedLocale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: maxDigits,
    })
      .formatToParts(1234.123) // Just to consider all possibilities
      .find((part) => part.type === "decimal")?.value ?? ","
  );
};
